<script setup>

import { ref } from "vue";
import CriarFollowUpModal from "./CriarFollowUp/CriarFollowUpModal.vue";
import ListaDePedidosCartao from "./ListaDePedidos/ListaDePedidosCartao.vue";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//======================= Campos de Controle =======================//
//==================================================================//

const controlesDesativados = ref(false);
const criandoFollowUp = ref(false);

//==================================================================//
//======================== Pedido de Compra ========================//
//==================================================================//

const pedidosDeCompra = ref([]);
const pedidoDeCompra = ref({});

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    controlesDesativados.value = update.controlesDesativados;

};

//==================================================================//
//================== Altera Pedidos de Compra ======================//
//==================================================================//

const alteraPedidosDeCompra = (update)=>{

    pedidosDeCompra.value = update;

};

//==================================================================//
//=========== Altera Pedido de Compra ==================//
//==================================================================//

const alteraPedidoDeCompra = (update={})=>{

    pedidoDeCompra.value = update

};

//==================================================================//
//=================== Altera Criando FollowUp ======================//
//==================================================================//

const alteraCriandoFollowUp = (update={})=>{

    criandoFollowUp.value = update.criandoFollowUp;
    alteraPedidoDeCompra(update?.pedidoDeCompra);

};

</script>

<template>

    <main 
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Criar FollowUps
        </h2>

        <ListaDePedidosCartao
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pedidosDeCompra="pedidosDeCompra"
            :controlesDesativados="controlesDesativados"
            :criandoFollowUp="criandoFollowUp"
            @update:pedidosDeCompra="alteraPedidosDeCompra"
            @update:pedidoDeCompra="alteraPedidoDeCompra"
            @update:criandoFollowUp="alteraCriandoFollowUp"
        ></ListaDePedidosCartao>

        <CriarFollowUpModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pedidoDeCompra="pedidoDeCompra"
            :controlesDesativados="controlesDesativados"
            :criandoFollowUp="criandoFollowUp"
            @update:criandoFollowUp="alteraCriandoFollowUp"
            @update:controlesDesativados="alteraControlesDesativados"
        ></CriarFollowUpModal>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>